import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 lg:gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 cursor-pointer">
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-play-circle-fill text-2xl text-primary-400"></i>
              </div>
              <span className="text-lg font-bold text-background-50 font-heading whitespace-nowrap">
                芒果视频
              </span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              芒果视频是蜜桃视频与糖豆视频之外值得推荐的优质视频平台，资源丰富、播放流畅，免费高清在线观看各类影视内容。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <ul className="space-y-2.5">
              {categories.slice(0, 5).map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/article/mangoshipin-vs-mitao-tangdou" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  平台对比
                </Link>
              </li>
              <li>
                <Link to="/article/top-10-shipin-pingtai-tuijian" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  平台推荐
                </Link>
              </li>
              <li>
                <Link to="/article/mangoshipin-app-tiyan" className="text-sm text-background-400 hover:text-primary-400 transition-colors cursor-pointer">
                  使用评测
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">平台对比</h4>
            <ul className="space-y-2.5">
              <li>
                <span className="text-sm text-background-400">芒果视频 vs 蜜桃视频</span>
              </li>
              <li>
                <span className="text-sm text-background-400">芒果视频 vs 糖豆视频</span>
              </li>
              <li>
                <span className="text-sm text-background-400">芒果视频 vs 蘑菇视频</span>
              </li>
              <li>
                <span className="text-sm text-background-400">芒果视频 vs 蓝莓视频</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-background-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-background-500">
            &copy; 2026 芒果视频 mangoshipin.com - 版权所有
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              隐私政策
            </a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              服务条款
            </a>
            <a href="#" className="text-sm text-background-500 hover:text-background-300 transition-colors cursor-pointer">
              联系我们
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}